import { Delegator, EnvironmentVariables } from './Environment.model';

export { EnvironmentVariables } from './Environment.model';

let delegator: Delegator = null;

const setDelegator = (environmentDelegator: Delegator): void => {
  delegator = environmentDelegator;
};

const get = (key: EnvironmentVariables, fallbackValue: string): string => {
  return delegator?.get(key) ?? fallbackValue;
};

export default {
  setDelegator,
  get,
};
